export const ERROR_CODES = {
    CONTEXT_LIMIT_EXCEED: 'CONTEXT_LIMIT_EXCEED',
} as const;